module.exports = __webpack_public_path__ + "static/img/task_appraise_3.32d05df6.png";